import React from "react";
import "../../assets/css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Copyright © Tirupur Jewellery-2025</p>
        <p>Developed by Aalan Techsoft</p>
      </div>
    </footer>
  );
};

export default Footer;